import util   from '../../common/AppUtil';

const ServerMode = 1;
const ApiCode = "Maintenance";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  }
}
  


// WEBPACK FOOTER //
// ./src/api/bas/maintenance.js